module.exports = __webpack_public_path__ + "b05f8e71f7d022977ba45e0d04bdb840.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Display/Components/Mute/ic_volume_up_white_24px.svg
// module id = 191
// module chunks = 6